module.exports = __webpack_public_path__ + "media/images/logo-everfactor-f628f4cc93ecf5a02671f29de42f530b.png";